// This file is auto-generated by @hey-api/openapi-ts

import { type Options, mvpApiListCompanies, mvpApiGetCompany, mvpApiListStores, mvpApiGetStore, mvpApiListDevices, mvpApiCreateDevice, mvpApiUpdateDevice, mvpApiListDevicePings, mvpApiCheckDeviceValidity, mvpApiListVideoCaptures, mvpApiListVideos, mvpApiCreateVideo, mvpApiGetVideo, mvpApiUpdateVideoTags, mvpApiListVideoExports, mvpApiCreateVideoExportRequest, mvpApiGetVideoExportRequest, mvpApiRegisterVideoImages, mvpApiListVideoTagNames, mvpApiCreateVideoTagName, mvpApiGetVideoTagName, mvpApiUpdateVideoTagName, mvpApiListVideoTimeTags, mvpApiCreateVideoTimeTag, mvpApiDeleteVideoTimeTag, mvpApiGetVideoTimeTag, mvpApiGetVideoTagsForStore, mvpApiUpdateVideoStatus, mvpApiUpdateVideoPropertyData, mvpApiGetImageUrls, mvpApiGetImageGalleryUrls, mvpApiGetSingleImageUrls, mvpApiGetSignedImageUrl, mvpApiGetImageRotation, mvpApiListJobs, mvpApiCreateJob, mvpApiListJobsInFlight, mvpApiListVideoJobs, mvpApiGetJob, mvpApiUpdateJob, mvpApiGetJobLogTail, mvpApiGetJobFile, mvpApiUpdateJobStage, mvpApiMarkStartedJob, mvpApiCompleteJob, mvpApiErrorOutJob, mvpApiStopJob, mvpApiRegisterImages, mvpApiListJobTasks, mvpApiCreateJobTasks, mvpApiGetJobTask, mvpApiCompleteJobTask, mvpApiSkipJobTask, mvpApiGetNextPendingJobTask, mvpApiListAllJobTasks, mvpApiTaskActivity, mvpApiCreateReviewTasks, mvpApiListToolWebsites, mvpApiShouldShowStaffTool, mvpApiListOosParcels, mvpApiGetOosParcel, mvpApiListOosEventBuffer, mvpApiGetOosEventFromBuffer, mvpApiListOosEventBatches, mvpApiGetOosEventBatch, mvpApiListPlanograms, mvpApiCreatePlanogram, mvpApiGetPlanogram, mvpApiGetPlanogramLabel, mvpApiUpdatePlanogramLabel, mvpApiListPlanogramImages, mvpApiCreatePlanogramImages, mvpApiGetPlanogramImage, mvpApiGetStoresInventory, mvpApiGetDevicesInventory } from '../sdk.gen';
import { queryOptions, infiniteQueryOptions, type InfiniteData, type DefaultError, type UseMutationOptions } from '@tanstack/react-query';
import type { MvpApiListCompaniesData, MvpApiListCompaniesResponse, MvpApiGetCompanyData, MvpApiListStoresData, MvpApiListStoresResponse, MvpApiGetStoreData, MvpApiListDevicesData, MvpApiListDevicesResponse, MvpApiCreateDeviceData, MvpApiCreateDeviceResponse, MvpApiUpdateDeviceData, MvpApiUpdateDeviceResponse, MvpApiListDevicePingsData, MvpApiListDevicePingsResponse, MvpApiCheckDeviceValidityData, MvpApiListVideoCapturesData, MvpApiListVideoCapturesResponse, MvpApiListVideosData, MvpApiListVideosResponse, MvpApiCreateVideoData, MvpApiGetVideoData, MvpApiUpdateVideoTagsData, MvpApiUpdateVideoTagsResponse, MvpApiListVideoExportsData, MvpApiListVideoExportsResponse, MvpApiCreateVideoExportRequestData, MvpApiCreateVideoExportRequestResponse, MvpApiGetVideoExportRequestData, MvpApiRegisterVideoImagesData, MvpApiListVideoTagNamesData, MvpApiListVideoTagNamesResponse, MvpApiCreateVideoTagNameData, MvpApiCreateVideoTagNameResponse, MvpApiGetVideoTagNameData, MvpApiUpdateVideoTagNameData, MvpApiUpdateVideoTagNameResponse, MvpApiListVideoTimeTagsData, MvpApiListVideoTimeTagsResponse, MvpApiCreateVideoTimeTagData, MvpApiCreateVideoTimeTagResponse, MvpApiDeleteVideoTimeTagData, MvpApiDeleteVideoTimeTagResponse, MvpApiGetVideoTimeTagData, MvpApiGetVideoTagsForStoreData, MvpApiUpdateVideoStatusData, MvpApiUpdateVideoPropertyDataData, MvpApiGetImageUrlsData, MvpApiGetImageUrlsResponse, MvpApiGetImageGalleryUrlsData, MvpApiGetImageGalleryUrlsResponse, MvpApiGetSingleImageUrlsData, MvpApiGetSignedImageUrlData, MvpApiGetImageRotationData, MvpApiListJobsData, MvpApiListJobsResponse, MvpApiCreateJobData, MvpApiCreateJobResponse, MvpApiListJobsInFlightData, MvpApiListJobsInFlightResponse, MvpApiListVideoJobsData, MvpApiListVideoJobsResponse, MvpApiGetJobData, MvpApiUpdateJobData, MvpApiUpdateJobResponse, MvpApiGetJobLogTailData, MvpApiGetJobFileData, MvpApiUpdateJobStageData, MvpApiUpdateJobStageResponse, MvpApiMarkStartedJobData, MvpApiMarkStartedJobResponse, MvpApiCompleteJobData, MvpApiCompleteJobResponse, MvpApiErrorOutJobData, MvpApiErrorOutJobResponse, MvpApiStopJobData, MvpApiStopJobResponse, MvpApiRegisterImagesData, MvpApiListJobTasksData, MvpApiCreateJobTasksData, MvpApiCreateJobTasksResponse, MvpApiGetJobTaskData, MvpApiCompleteJobTaskData, MvpApiCompleteJobTaskResponse, MvpApiSkipJobTaskData, MvpApiSkipJobTaskResponse, MvpApiGetNextPendingJobTaskData, MvpApiListAllJobTasksData, MvpApiListAllJobTasksResponse, MvpApiTaskActivityData, MvpApiTaskActivityResponse, MvpApiCreateReviewTasksData, MvpApiCreateReviewTasksResponse, MvpApiListToolWebsitesData, MvpApiShouldShowStaffToolData, MvpApiListOosParcelsData, MvpApiListOosParcelsResponse, MvpApiGetOosParcelData, MvpApiListOosEventBufferData, MvpApiListOosEventBufferResponse, MvpApiGetOosEventFromBufferData, MvpApiListOosEventBatchesData, MvpApiListOosEventBatchesResponse, MvpApiGetOosEventBatchData, MvpApiListPlanogramsData, MvpApiListPlanogramsResponse, MvpApiCreatePlanogramData, MvpApiCreatePlanogramResponse, MvpApiGetPlanogramData, MvpApiGetPlanogramLabelData, MvpApiUpdatePlanogramLabelData, MvpApiUpdatePlanogramLabelResponse, MvpApiListPlanogramImagesData, MvpApiCreatePlanogramImagesData, MvpApiCreatePlanogramImagesResponse, MvpApiGetPlanogramImageData, MvpApiGetStoresInventoryData, MvpApiGetDevicesInventoryData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const mvpApiListCompaniesQueryKey = (options?: Options<MvpApiListCompaniesData>) => createQueryKey('mvpApiListCompanies', options);

/**
 * List Companies
 */
export const mvpApiListCompaniesOptions = (options?: Options<MvpApiListCompaniesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListCompaniesQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const mvpApiListCompaniesInfiniteQueryKey = (options?: Options<MvpApiListCompaniesData>): QueryKey<Options<MvpApiListCompaniesData>> => createQueryKey('mvpApiListCompanies', options, true);

/**
 * List Companies
 */
export const mvpApiListCompaniesInfiniteOptions = (options?: Options<MvpApiListCompaniesData>) => {
    return infiniteQueryOptions<MvpApiListCompaniesResponse, DefaultError, InfiniteData<MvpApiListCompaniesResponse>, QueryKey<Options<MvpApiListCompaniesData>>, number | Pick<QueryKey<Options<MvpApiListCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListCompaniesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListCompanies({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListCompaniesInfiniteQueryKey(options)
    });
};

export const mvpApiGetCompanyQueryKey = (options: Options<MvpApiGetCompanyData>) => createQueryKey('mvpApiGetCompany', options);

/**
 * Get Company
 */
export const mvpApiGetCompanyOptions = (options: Options<MvpApiGetCompanyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetCompanyQueryKey(options)
    });
};

export const mvpApiListStoresQueryKey = (options?: Options<MvpApiListStoresData>) => createQueryKey('mvpApiListStores', options);

/**
 * List Stores
 */
export const mvpApiListStoresOptions = (options?: Options<MvpApiListStoresData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListStores({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStoresQueryKey(options)
    });
};

export const mvpApiListStoresInfiniteQueryKey = (options?: Options<MvpApiListStoresData>): QueryKey<Options<MvpApiListStoresData>> => createQueryKey('mvpApiListStores', options, true);

/**
 * List Stores
 */
export const mvpApiListStoresInfiniteOptions = (options?: Options<MvpApiListStoresData>) => {
    return infiniteQueryOptions<MvpApiListStoresResponse, DefaultError, InfiniteData<MvpApiListStoresResponse>, QueryKey<Options<MvpApiListStoresData>>, number | Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListStores({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListStoresInfiniteQueryKey(options)
    });
};

export const mvpApiGetStoreQueryKey = (options: Options<MvpApiGetStoreData>) => createQueryKey('mvpApiGetStore', options);

/**
 * Get Store
 */
export const mvpApiGetStoreOptions = (options: Options<MvpApiGetStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetStoreQueryKey(options)
    });
};

export const mvpApiListDevicesQueryKey = (options?: Options<MvpApiListDevicesData>) => createQueryKey('mvpApiListDevices', options);

/**
 * List Devices
 */
export const mvpApiListDevicesOptions = (options?: Options<MvpApiListDevicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListDevices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListDevicesQueryKey(options)
    });
};

export const mvpApiListDevicesInfiniteQueryKey = (options?: Options<MvpApiListDevicesData>): QueryKey<Options<MvpApiListDevicesData>> => createQueryKey('mvpApiListDevices', options, true);

/**
 * List Devices
 */
export const mvpApiListDevicesInfiniteOptions = (options?: Options<MvpApiListDevicesData>) => {
    return infiniteQueryOptions<MvpApiListDevicesResponse, DefaultError, InfiniteData<MvpApiListDevicesResponse>, QueryKey<Options<MvpApiListDevicesData>>, number | Pick<QueryKey<Options<MvpApiListDevicesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListDevicesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListDevices({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListDevicesInfiniteQueryKey(options)
    });
};

export const mvpApiCreateDeviceQueryKey = (options: Options<MvpApiCreateDeviceData>) => createQueryKey('mvpApiCreateDevice', options);

/**
 * Create Device
 */
export const mvpApiCreateDeviceOptions = (options: Options<MvpApiCreateDeviceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateDevice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateDeviceQueryKey(options)
    });
};

/**
 * Create Device
 */
export const mvpApiCreateDeviceMutation = (options?: Partial<Options<MvpApiCreateDeviceData>>): UseMutationOptions<MvpApiCreateDeviceResponse, DefaultError, Options<MvpApiCreateDeviceData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateDeviceResponse, DefaultError, Options<MvpApiCreateDeviceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateDevice({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiUpdateDeviceQueryKey = (options: Options<MvpApiUpdateDeviceData>) => createQueryKey('mvpApiUpdateDevice', options);

/**
 * Update Device
 */
export const mvpApiUpdateDeviceOptions = (options: Options<MvpApiUpdateDeviceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUpdateDevice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUpdateDeviceQueryKey(options)
    });
};

/**
 * Update Device
 */
export const mvpApiUpdateDeviceMutation = (options?: Partial<Options<MvpApiUpdateDeviceData>>): UseMutationOptions<MvpApiUpdateDeviceResponse, DefaultError, Options<MvpApiUpdateDeviceData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateDeviceResponse, DefaultError, Options<MvpApiUpdateDeviceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateDevice({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListDevicePingsQueryKey = (options?: Options<MvpApiListDevicePingsData>) => createQueryKey('mvpApiListDevicePings', options);

/**
 * List Device Pings
 */
export const mvpApiListDevicePingsOptions = (options?: Options<MvpApiListDevicePingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListDevicePings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListDevicePingsQueryKey(options)
    });
};

export const mvpApiListDevicePingsInfiniteQueryKey = (options?: Options<MvpApiListDevicePingsData>): QueryKey<Options<MvpApiListDevicePingsData>> => createQueryKey('mvpApiListDevicePings', options, true);

/**
 * List Device Pings
 */
export const mvpApiListDevicePingsInfiniteOptions = (options?: Options<MvpApiListDevicePingsData>) => {
    return infiniteQueryOptions<MvpApiListDevicePingsResponse, DefaultError, InfiniteData<MvpApiListDevicePingsResponse>, QueryKey<Options<MvpApiListDevicePingsData>>, number | Pick<QueryKey<Options<MvpApiListDevicePingsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListDevicePingsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListDevicePings({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListDevicePingsInfiniteQueryKey(options)
    });
};

export const mvpApiCheckDeviceValidityQueryKey = (options: Options<MvpApiCheckDeviceValidityData>) => createQueryKey('mvpApiCheckDeviceValidity', options);

/**
 * Check Device Validity
 */
export const mvpApiCheckDeviceValidityOptions = (options: Options<MvpApiCheckDeviceValidityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCheckDeviceValidity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCheckDeviceValidityQueryKey(options)
    });
};

export const mvpApiListVideoCapturesQueryKey = (options?: Options<MvpApiListVideoCapturesData>) => createQueryKey('mvpApiListVideoCaptures', options);

/**
 * List Video Captures
 */
export const mvpApiListVideoCapturesOptions = (options?: Options<MvpApiListVideoCapturesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideoCaptures({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoCapturesQueryKey(options)
    });
};

export const mvpApiListVideoCapturesInfiniteQueryKey = (options?: Options<MvpApiListVideoCapturesData>): QueryKey<Options<MvpApiListVideoCapturesData>> => createQueryKey('mvpApiListVideoCaptures', options, true);

/**
 * List Video Captures
 */
export const mvpApiListVideoCapturesInfiniteOptions = (options?: Options<MvpApiListVideoCapturesData>) => {
    return infiniteQueryOptions<MvpApiListVideoCapturesResponse, DefaultError, InfiniteData<MvpApiListVideoCapturesResponse>, QueryKey<Options<MvpApiListVideoCapturesData>>, number | Pick<QueryKey<Options<MvpApiListVideoCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideoCapturesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideoCaptures({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoCapturesInfiniteQueryKey(options)
    });
};

export const mvpApiListVideosQueryKey = (options?: Options<MvpApiListVideosData>) => createQueryKey('mvpApiListVideos', options);

/**
 * List Videos
 */
export const mvpApiListVideosOptions = (options?: Options<MvpApiListVideosData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideosQueryKey(options)
    });
};

export const mvpApiListVideosInfiniteQueryKey = (options?: Options<MvpApiListVideosData>): QueryKey<Options<MvpApiListVideosData>> => createQueryKey('mvpApiListVideos', options, true);

/**
 * List Videos
 */
export const mvpApiListVideosInfiniteOptions = (options?: Options<MvpApiListVideosData>) => {
    return infiniteQueryOptions<MvpApiListVideosResponse, DefaultError, InfiniteData<MvpApiListVideosResponse>, QueryKey<Options<MvpApiListVideosData>>, number | Pick<QueryKey<Options<MvpApiListVideosData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideosData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideos({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideosInfiniteQueryKey(options)
    });
};

export const mvpApiCreateVideoQueryKey = (options: Options<MvpApiCreateVideoData>) => createQueryKey('mvpApiCreateVideo', options);

/**
 * Create Video
 */
export const mvpApiCreateVideoOptions = (options: Options<MvpApiCreateVideoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateVideo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateVideoQueryKey(options)
    });
};

/**
 * Create Video
 */
export const mvpApiCreateVideoMutation = (options?: Partial<Options<MvpApiCreateVideoData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateVideoData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateVideoData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateVideo({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoQueryKey = (options: Options<MvpApiGetVideoData>) => createQueryKey('mvpApiGetVideo', options);

/**
 * Get Video
 */
export const mvpApiGetVideoOptions = (options: Options<MvpApiGetVideoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetVideo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetVideoQueryKey(options)
    });
};

/**
 * Update Video Tags
 */
export const mvpApiUpdateVideoTagsMutation = (options?: Partial<Options<MvpApiUpdateVideoTagsData>>): UseMutationOptions<MvpApiUpdateVideoTagsResponse, DefaultError, Options<MvpApiUpdateVideoTagsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateVideoTagsResponse, DefaultError, Options<MvpApiUpdateVideoTagsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateVideoTags({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoExportsQueryKey = (options?: Options<MvpApiListVideoExportsData>) => createQueryKey('mvpApiListVideoExports', options);

/**
 * List Video Exports
 */
export const mvpApiListVideoExportsOptions = (options?: Options<MvpApiListVideoExportsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideoExports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoExportsQueryKey(options)
    });
};

export const mvpApiListVideoExportsInfiniteQueryKey = (options?: Options<MvpApiListVideoExportsData>): QueryKey<Options<MvpApiListVideoExportsData>> => createQueryKey('mvpApiListVideoExports', options, true);

/**
 * List Video Exports
 */
export const mvpApiListVideoExportsInfiniteOptions = (options?: Options<MvpApiListVideoExportsData>) => {
    return infiniteQueryOptions<MvpApiListVideoExportsResponse, DefaultError, InfiniteData<MvpApiListVideoExportsResponse>, QueryKey<Options<MvpApiListVideoExportsData>>, number | Pick<QueryKey<Options<MvpApiListVideoExportsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideoExportsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideoExports({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoExportsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateVideoExportRequestQueryKey = (options: Options<MvpApiCreateVideoExportRequestData>) => createQueryKey('mvpApiCreateVideoExportRequest', options);

/**
 * Create Video Export Request
 */
export const mvpApiCreateVideoExportRequestOptions = (options: Options<MvpApiCreateVideoExportRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateVideoExportRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateVideoExportRequestQueryKey(options)
    });
};

/**
 * Create Video Export Request
 */
export const mvpApiCreateVideoExportRequestMutation = (options?: Partial<Options<MvpApiCreateVideoExportRequestData>>): UseMutationOptions<MvpApiCreateVideoExportRequestResponse, DefaultError, Options<MvpApiCreateVideoExportRequestData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoExportRequestResponse, DefaultError, Options<MvpApiCreateVideoExportRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateVideoExportRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoExportRequestQueryKey = (options: Options<MvpApiGetVideoExportRequestData>) => createQueryKey('mvpApiGetVideoExportRequest', options);

/**
 * Get Video Export Request
 */
export const mvpApiGetVideoExportRequestOptions = (options: Options<MvpApiGetVideoExportRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetVideoExportRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetVideoExportRequestQueryKey(options)
    });
};

export const mvpApiRegisterVideoImagesQueryKey = (options: Options<MvpApiRegisterVideoImagesData>) => createQueryKey('mvpApiRegisterVideoImages', options);

/**
 * Register Video Images
 */
export const mvpApiRegisterVideoImagesOptions = (options: Options<MvpApiRegisterVideoImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiRegisterVideoImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiRegisterVideoImagesQueryKey(options)
    });
};

/**
 * Register Video Images
 */
export const mvpApiRegisterVideoImagesMutation = (options?: Partial<Options<MvpApiRegisterVideoImagesData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterVideoImagesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterVideoImagesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiRegisterVideoImages({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoTagNamesQueryKey = (options?: Options<MvpApiListVideoTagNamesData>) => createQueryKey('mvpApiListVideoTagNames', options);

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNamesOptions = (options?: Options<MvpApiListVideoTagNamesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideoTagNames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoTagNamesQueryKey(options)
    });
};

export const mvpApiListVideoTagNamesInfiniteQueryKey = (options?: Options<MvpApiListVideoTagNamesData>): QueryKey<Options<MvpApiListVideoTagNamesData>> => createQueryKey('mvpApiListVideoTagNames', options, true);

/**
 * List Video Tag Names
 */
export const mvpApiListVideoTagNamesInfiniteOptions = (options?: Options<MvpApiListVideoTagNamesData>) => {
    return infiniteQueryOptions<MvpApiListVideoTagNamesResponse, DefaultError, InfiniteData<MvpApiListVideoTagNamesResponse>, QueryKey<Options<MvpApiListVideoTagNamesData>>, number | Pick<QueryKey<Options<MvpApiListVideoTagNamesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideoTagNamesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideoTagNames({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoTagNamesInfiniteQueryKey(options)
    });
};

export const mvpApiCreateVideoTagNameQueryKey = (options: Options<MvpApiCreateVideoTagNameData>) => createQueryKey('mvpApiCreateVideoTagName', options);

/**
 * Create Video Tag Name
 */
export const mvpApiCreateVideoTagNameOptions = (options: Options<MvpApiCreateVideoTagNameData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateVideoTagName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateVideoTagNameQueryKey(options)
    });
};

/**
 * Create Video Tag Name
 */
export const mvpApiCreateVideoTagNameMutation = (options?: Partial<Options<MvpApiCreateVideoTagNameData>>): UseMutationOptions<MvpApiCreateVideoTagNameResponse, DefaultError, Options<MvpApiCreateVideoTagNameData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoTagNameResponse, DefaultError, Options<MvpApiCreateVideoTagNameData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateVideoTagName({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoTagNameQueryKey = (options: Options<MvpApiGetVideoTagNameData>) => createQueryKey('mvpApiGetVideoTagName', options);

/**
 * Get Video Tag Name
 */
export const mvpApiGetVideoTagNameOptions = (options: Options<MvpApiGetVideoTagNameData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetVideoTagName({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetVideoTagNameQueryKey(options)
    });
};

/**
 * Update Video Tag Name
 */
export const mvpApiUpdateVideoTagNameMutation = (options?: Partial<Options<MvpApiUpdateVideoTagNameData>>): UseMutationOptions<MvpApiUpdateVideoTagNameResponse, DefaultError, Options<MvpApiUpdateVideoTagNameData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateVideoTagNameResponse, DefaultError, Options<MvpApiUpdateVideoTagNameData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateVideoTagName({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListVideoTimeTagsQueryKey = (options?: Options<MvpApiListVideoTimeTagsData>) => createQueryKey('mvpApiListVideoTimeTags', options);

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTagsOptions = (options?: Options<MvpApiListVideoTimeTagsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideoTimeTags({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoTimeTagsQueryKey(options)
    });
};

export const mvpApiListVideoTimeTagsInfiniteQueryKey = (options?: Options<MvpApiListVideoTimeTagsData>): QueryKey<Options<MvpApiListVideoTimeTagsData>> => createQueryKey('mvpApiListVideoTimeTags', options, true);

/**
 * List Video Time Tags
 */
export const mvpApiListVideoTimeTagsInfiniteOptions = (options?: Options<MvpApiListVideoTimeTagsData>) => {
    return infiniteQueryOptions<MvpApiListVideoTimeTagsResponse, DefaultError, InfiniteData<MvpApiListVideoTimeTagsResponse>, QueryKey<Options<MvpApiListVideoTimeTagsData>>, number | Pick<QueryKey<Options<MvpApiListVideoTimeTagsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideoTimeTagsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideoTimeTags({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoTimeTagsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateVideoTimeTagQueryKey = (options: Options<MvpApiCreateVideoTimeTagData>) => createQueryKey('mvpApiCreateVideoTimeTag', options);

/**
 * Create Video Time Tag
 */
export const mvpApiCreateVideoTimeTagOptions = (options: Options<MvpApiCreateVideoTimeTagData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateVideoTimeTag({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateVideoTimeTagQueryKey(options)
    });
};

/**
 * Create Video Time Tag
 */
export const mvpApiCreateVideoTimeTagMutation = (options?: Partial<Options<MvpApiCreateVideoTimeTagData>>): UseMutationOptions<MvpApiCreateVideoTimeTagResponse, DefaultError, Options<MvpApiCreateVideoTimeTagData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateVideoTimeTagResponse, DefaultError, Options<MvpApiCreateVideoTimeTagData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateVideoTimeTag({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete Video Time Tag
 */
export const mvpApiDeleteVideoTimeTagMutation = (options?: Partial<Options<MvpApiDeleteVideoTimeTagData>>): UseMutationOptions<MvpApiDeleteVideoTimeTagResponse, DefaultError, Options<MvpApiDeleteVideoTimeTagData>> => {
    const mutationOptions: UseMutationOptions<MvpApiDeleteVideoTimeTagResponse, DefaultError, Options<MvpApiDeleteVideoTimeTagData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiDeleteVideoTimeTag({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetVideoTimeTagQueryKey = (options: Options<MvpApiGetVideoTimeTagData>) => createQueryKey('mvpApiGetVideoTimeTag', options);

/**
 * Get Video Time Tag
 */
export const mvpApiGetVideoTimeTagOptions = (options: Options<MvpApiGetVideoTimeTagData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetVideoTimeTag({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetVideoTimeTagQueryKey(options)
    });
};

export const mvpApiGetVideoTagsForStoreQueryKey = (options: Options<MvpApiGetVideoTagsForStoreData>) => createQueryKey('mvpApiGetVideoTagsForStore', options);

/**
 * Get Video Tags For Store
 */
export const mvpApiGetVideoTagsForStoreOptions = (options: Options<MvpApiGetVideoTagsForStoreData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetVideoTagsForStore({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetVideoTagsForStoreQueryKey(options)
    });
};

export const mvpApiUpdateVideoStatusQueryKey = (options: Options<MvpApiUpdateVideoStatusData>) => createQueryKey('mvpApiUpdateVideoStatus', options);

/**
 * Update Video Status
 */
export const mvpApiUpdateVideoStatusOptions = (options: Options<MvpApiUpdateVideoStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUpdateVideoStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUpdateVideoStatusQueryKey(options)
    });
};

/**
 * Update Video Status
 */
export const mvpApiUpdateVideoStatusMutation = (options?: Partial<Options<MvpApiUpdateVideoStatusData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoStatusData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateVideoStatus({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiUpdateVideoPropertyDataQueryKey = (options: Options<MvpApiUpdateVideoPropertyDataData>) => createQueryKey('mvpApiUpdateVideoPropertyData', options);

/**
 * Update Video Property Data
 */
export const mvpApiUpdateVideoPropertyDataOptions = (options: Options<MvpApiUpdateVideoPropertyDataData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUpdateVideoPropertyData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUpdateVideoPropertyDataQueryKey(options)
    });
};

/**
 * Update Video Property Data
 */
export const mvpApiUpdateVideoPropertyDataMutation = (options?: Partial<Options<MvpApiUpdateVideoPropertyDataData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoPropertyDataData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUpdateVideoPropertyDataData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateVideoPropertyData({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetImageUrlsQueryKey = (options: Options<MvpApiGetImageUrlsData>) => createQueryKey('mvpApiGetImageUrls', options);

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrlsOptions = (options: Options<MvpApiGetImageUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetImageUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetImageUrlsQueryKey(options)
    });
};

export const mvpApiGetImageUrlsInfiniteQueryKey = (options: Options<MvpApiGetImageUrlsData>): QueryKey<Options<MvpApiGetImageUrlsData>> => createQueryKey('mvpApiGetImageUrls', options, true);

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrlsInfiniteOptions = (options: Options<MvpApiGetImageUrlsData>) => {
    return infiniteQueryOptions<MvpApiGetImageUrlsResponse, DefaultError, InfiniteData<MvpApiGetImageUrlsResponse>, QueryKey<Options<MvpApiGetImageUrlsData>>, number | Pick<QueryKey<Options<MvpApiGetImageUrlsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiGetImageUrlsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiGetImageUrls({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetImageUrlsInfiniteQueryKey(options)
    });
};

/**
 * Get Image Urls
 */
export const mvpApiGetImageUrlsMutation = (options?: Partial<Options<MvpApiGetImageUrlsData>>): UseMutationOptions<MvpApiGetImageUrlsResponse, DefaultError, Options<MvpApiGetImageUrlsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiGetImageUrlsResponse, DefaultError, Options<MvpApiGetImageUrlsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiGetImageUrls({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetImageGalleryUrlsQueryKey = (options: Options<MvpApiGetImageGalleryUrlsData>) => createQueryKey('mvpApiGetImageGalleryUrls', options);

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrlsOptions = (options: Options<MvpApiGetImageGalleryUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetImageGalleryUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetImageGalleryUrlsQueryKey(options)
    });
};

export const mvpApiGetImageGalleryUrlsInfiniteQueryKey = (options: Options<MvpApiGetImageGalleryUrlsData>): QueryKey<Options<MvpApiGetImageGalleryUrlsData>> => createQueryKey('mvpApiGetImageGalleryUrls', options, true);

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrlsInfiniteOptions = (options: Options<MvpApiGetImageGalleryUrlsData>) => {
    return infiniteQueryOptions<MvpApiGetImageGalleryUrlsResponse, DefaultError, InfiniteData<MvpApiGetImageGalleryUrlsResponse>, QueryKey<Options<MvpApiGetImageGalleryUrlsData>>, number | Pick<QueryKey<Options<MvpApiGetImageGalleryUrlsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiGetImageGalleryUrlsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiGetImageGalleryUrls({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetImageGalleryUrlsInfiniteQueryKey(options)
    });
};

/**
 * Get Image Gallery Urls
 */
export const mvpApiGetImageGalleryUrlsMutation = (options?: Partial<Options<MvpApiGetImageGalleryUrlsData>>): UseMutationOptions<MvpApiGetImageGalleryUrlsResponse, DefaultError, Options<MvpApiGetImageGalleryUrlsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiGetImageGalleryUrlsResponse, DefaultError, Options<MvpApiGetImageGalleryUrlsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiGetImageGalleryUrls({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetSingleImageUrlsQueryKey = (options: Options<MvpApiGetSingleImageUrlsData>) => createQueryKey('mvpApiGetSingleImageUrls', options);

/**
 * Get Single Image Urls
 */
export const mvpApiGetSingleImageUrlsOptions = (options: Options<MvpApiGetSingleImageUrlsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetSingleImageUrls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetSingleImageUrlsQueryKey(options)
    });
};

export const mvpApiGetSignedImageUrlQueryKey = (options: Options<MvpApiGetSignedImageUrlData>) => createQueryKey('mvpApiGetSignedImageUrl', options);

/**
 * Get Signed Image Url
 */
export const mvpApiGetSignedImageUrlOptions = (options: Options<MvpApiGetSignedImageUrlData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetSignedImageUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetSignedImageUrlQueryKey(options)
    });
};

export const mvpApiGetImageRotationQueryKey = (options: Options<MvpApiGetImageRotationData>) => createQueryKey('mvpApiGetImageRotation', options);

/**
 * Get Image Rotation
 */
export const mvpApiGetImageRotationOptions = (options: Options<MvpApiGetImageRotationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetImageRotation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetImageRotationQueryKey(options)
    });
};

export const mvpApiListJobsQueryKey = (options?: Options<MvpApiListJobsData>) => createQueryKey('mvpApiListJobs', options);

/**
 * List Jobs
 */
export const mvpApiListJobsOptions = (options?: Options<MvpApiListJobsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListJobsQueryKey(options)
    });
};

export const mvpApiListJobsInfiniteQueryKey = (options?: Options<MvpApiListJobsData>): QueryKey<Options<MvpApiListJobsData>> => createQueryKey('mvpApiListJobs', options, true);

/**
 * List Jobs
 */
export const mvpApiListJobsInfiniteOptions = (options?: Options<MvpApiListJobsData>) => {
    return infiniteQueryOptions<MvpApiListJobsResponse, DefaultError, InfiniteData<MvpApiListJobsResponse>, QueryKey<Options<MvpApiListJobsData>>, number | Pick<QueryKey<Options<MvpApiListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListJobs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListJobsInfiniteQueryKey(options)
    });
};

export const mvpApiCreateJobQueryKey = (options: Options<MvpApiCreateJobData>) => createQueryKey('mvpApiCreateJob', options);

/**
 * Create Job
 */
export const mvpApiCreateJobOptions = (options: Options<MvpApiCreateJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateJobQueryKey(options)
    });
};

/**
 * Create Job
 */
export const mvpApiCreateJobMutation = (options?: Partial<Options<MvpApiCreateJobData>>): UseMutationOptions<MvpApiCreateJobResponse, DefaultError, Options<MvpApiCreateJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateJobResponse, DefaultError, Options<MvpApiCreateJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListJobsInFlightQueryKey = (options?: Options<MvpApiListJobsInFlightData>) => createQueryKey('mvpApiListJobsInFlight', options);

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlightOptions = (options?: Options<MvpApiListJobsInFlightData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListJobsInFlight({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListJobsInFlightQueryKey(options)
    });
};

export const mvpApiListJobsInFlightInfiniteQueryKey = (options?: Options<MvpApiListJobsInFlightData>): QueryKey<Options<MvpApiListJobsInFlightData>> => createQueryKey('mvpApiListJobsInFlight', options, true);

/**
 * List Jobs In Flight
 */
export const mvpApiListJobsInFlightInfiniteOptions = (options?: Options<MvpApiListJobsInFlightData>) => {
    return infiniteQueryOptions<MvpApiListJobsInFlightResponse, DefaultError, InfiniteData<MvpApiListJobsInFlightResponse>, QueryKey<Options<MvpApiListJobsInFlightData>>, number | Pick<QueryKey<Options<MvpApiListJobsInFlightData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListJobsInFlightData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListJobsInFlight({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListJobsInFlightInfiniteQueryKey(options)
    });
};

export const mvpApiListVideoJobsQueryKey = (options: Options<MvpApiListVideoJobsData>) => createQueryKey('mvpApiListVideoJobs', options);

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobsOptions = (options: Options<MvpApiListVideoJobsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListVideoJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoJobsQueryKey(options)
    });
};

export const mvpApiListVideoJobsInfiniteQueryKey = (options: Options<MvpApiListVideoJobsData>): QueryKey<Options<MvpApiListVideoJobsData>> => createQueryKey('mvpApiListVideoJobs', options, true);

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobsInfiniteOptions = (options: Options<MvpApiListVideoJobsData>) => {
    return infiniteQueryOptions<MvpApiListVideoJobsResponse, DefaultError, InfiniteData<MvpApiListVideoJobsResponse>, QueryKey<Options<MvpApiListVideoJobsData>>, number | Pick<QueryKey<Options<MvpApiListVideoJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListVideoJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListVideoJobs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListVideoJobsInfiniteQueryKey(options)
    });
};

/**
 * List Video Jobs
 */
export const mvpApiListVideoJobsMutation = (options?: Partial<Options<MvpApiListVideoJobsData>>): UseMutationOptions<MvpApiListVideoJobsResponse, DefaultError, Options<MvpApiListVideoJobsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiListVideoJobsResponse, DefaultError, Options<MvpApiListVideoJobsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiListVideoJobs({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobQueryKey = (options: Options<MvpApiGetJobData>) => createQueryKey('mvpApiGetJob', options);

/**
 * Get Job
 */
export const mvpApiGetJobOptions = (options: Options<MvpApiGetJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetJobQueryKey(options)
    });
};

/**
 * Update Job
 */
export const mvpApiUpdateJobMutation = (options?: Partial<Options<MvpApiUpdateJobData>>): UseMutationOptions<MvpApiUpdateJobResponse, DefaultError, Options<MvpApiUpdateJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateJobResponse, DefaultError, Options<MvpApiUpdateJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobLogTailQueryKey = (options: Options<MvpApiGetJobLogTailData>) => createQueryKey('mvpApiGetJobLogTail', options);

/**
 * Get Job Log Tail
 */
export const mvpApiGetJobLogTailOptions = (options: Options<MvpApiGetJobLogTailData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetJobLogTail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetJobLogTailQueryKey(options)
    });
};

export const mvpApiGetJobFileQueryKey = (options: Options<MvpApiGetJobFileData>) => createQueryKey('mvpApiGetJobFile', options);

/**
 * Get Job File
 */
export const mvpApiGetJobFileOptions = (options: Options<MvpApiGetJobFileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetJobFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetJobFileQueryKey(options)
    });
};

export const mvpApiUpdateJobStageQueryKey = (options: Options<MvpApiUpdateJobStageData>) => createQueryKey('mvpApiUpdateJobStage', options);

/**
 * Update Job Stage
 */
export const mvpApiUpdateJobStageOptions = (options: Options<MvpApiUpdateJobStageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiUpdateJobStage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiUpdateJobStageQueryKey(options)
    });
};

/**
 * Update Job Stage
 */
export const mvpApiUpdateJobStageMutation = (options?: Partial<Options<MvpApiUpdateJobStageData>>): UseMutationOptions<MvpApiUpdateJobStageResponse, DefaultError, Options<MvpApiUpdateJobStageData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateJobStageResponse, DefaultError, Options<MvpApiUpdateJobStageData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdateJobStage({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiMarkStartedJobQueryKey = (options: Options<MvpApiMarkStartedJobData>) => createQueryKey('mvpApiMarkStartedJob', options);

/**
 * Mark Started Job
 */
export const mvpApiMarkStartedJobOptions = (options: Options<MvpApiMarkStartedJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiMarkStartedJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiMarkStartedJobQueryKey(options)
    });
};

/**
 * Mark Started Job
 */
export const mvpApiMarkStartedJobMutation = (options?: Partial<Options<MvpApiMarkStartedJobData>>): UseMutationOptions<MvpApiMarkStartedJobResponse, DefaultError, Options<MvpApiMarkStartedJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiMarkStartedJobResponse, DefaultError, Options<MvpApiMarkStartedJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiMarkStartedJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiCompleteJobQueryKey = (options: Options<MvpApiCompleteJobData>) => createQueryKey('mvpApiCompleteJob', options);

/**
 * Complete Job
 */
export const mvpApiCompleteJobOptions = (options: Options<MvpApiCompleteJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCompleteJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCompleteJobQueryKey(options)
    });
};

/**
 * Complete Job
 */
export const mvpApiCompleteJobMutation = (options?: Partial<Options<MvpApiCompleteJobData>>): UseMutationOptions<MvpApiCompleteJobResponse, DefaultError, Options<MvpApiCompleteJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCompleteJobResponse, DefaultError, Options<MvpApiCompleteJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCompleteJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiErrorOutJobQueryKey = (options: Options<MvpApiErrorOutJobData>) => createQueryKey('mvpApiErrorOutJob', options);

/**
 * Error Out Job
 */
export const mvpApiErrorOutJobOptions = (options: Options<MvpApiErrorOutJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiErrorOutJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiErrorOutJobQueryKey(options)
    });
};

/**
 * Error Out Job
 */
export const mvpApiErrorOutJobMutation = (options?: Partial<Options<MvpApiErrorOutJobData>>): UseMutationOptions<MvpApiErrorOutJobResponse, DefaultError, Options<MvpApiErrorOutJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiErrorOutJobResponse, DefaultError, Options<MvpApiErrorOutJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiErrorOutJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiStopJobQueryKey = (options: Options<MvpApiStopJobData>) => createQueryKey('mvpApiStopJob', options);

/**
 * Stop Job
 */
export const mvpApiStopJobOptions = (options: Options<MvpApiStopJobData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiStopJob({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiStopJobQueryKey(options)
    });
};

/**
 * Stop Job
 */
export const mvpApiStopJobMutation = (options?: Partial<Options<MvpApiStopJobData>>): UseMutationOptions<MvpApiStopJobResponse, DefaultError, Options<MvpApiStopJobData>> => {
    const mutationOptions: UseMutationOptions<MvpApiStopJobResponse, DefaultError, Options<MvpApiStopJobData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiStopJob({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiRegisterImagesQueryKey = (options: Options<MvpApiRegisterImagesData>) => createQueryKey('mvpApiRegisterImages', options);

/**
 * Register Images
 */
export const mvpApiRegisterImagesOptions = (options: Options<MvpApiRegisterImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiRegisterImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiRegisterImagesQueryKey(options)
    });
};

/**
 * Register Images
 */
export const mvpApiRegisterImagesMutation = (options?: Partial<Options<MvpApiRegisterImagesData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterImagesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiRegisterImagesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiRegisterImages({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListJobTasksQueryKey = (options: Options<MvpApiListJobTasksData>) => createQueryKey('mvpApiListJobTasks', options);

/**
 * List Job Tasks
 */
export const mvpApiListJobTasksOptions = (options: Options<MvpApiListJobTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListJobTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListJobTasksQueryKey(options)
    });
};

export const mvpApiCreateJobTasksQueryKey = (options: Options<MvpApiCreateJobTasksData>) => createQueryKey('mvpApiCreateJobTasks', options);

/**
 * Create Job Tasks
 */
export const mvpApiCreateJobTasksOptions = (options: Options<MvpApiCreateJobTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateJobTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateJobTasksQueryKey(options)
    });
};

/**
 * Create Job Tasks
 */
export const mvpApiCreateJobTasksMutation = (options?: Partial<Options<MvpApiCreateJobTasksData>>): UseMutationOptions<MvpApiCreateJobTasksResponse, DefaultError, Options<MvpApiCreateJobTasksData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateJobTasksResponse, DefaultError, Options<MvpApiCreateJobTasksData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateJobTasks({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetJobTaskQueryKey = (options: Options<MvpApiGetJobTaskData>) => createQueryKey('mvpApiGetJobTask', options);

/**
 * Get Job Task
 */
export const mvpApiGetJobTaskOptions = (options: Options<MvpApiGetJobTaskData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetJobTask({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetJobTaskQueryKey(options)
    });
};

/**
 * Complete Job Task
 */
export const mvpApiCompleteJobTaskMutation = (options?: Partial<Options<MvpApiCompleteJobTaskData>>): UseMutationOptions<MvpApiCompleteJobTaskResponse, DefaultError, Options<MvpApiCompleteJobTaskData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCompleteJobTaskResponse, DefaultError, Options<MvpApiCompleteJobTaskData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCompleteJobTask({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Skip Job Task
 */
export const mvpApiSkipJobTaskMutation = (options?: Partial<Options<MvpApiSkipJobTaskData>>): UseMutationOptions<MvpApiSkipJobTaskResponse, DefaultError, Options<MvpApiSkipJobTaskData>> => {
    const mutationOptions: UseMutationOptions<MvpApiSkipJobTaskResponse, DefaultError, Options<MvpApiSkipJobTaskData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiSkipJobTask({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetNextPendingJobTaskQueryKey = (options: Options<MvpApiGetNextPendingJobTaskData>) => createQueryKey('mvpApiGetNextPendingJobTask', options);

/**
 * Get Next Pending Job Task
 */
export const mvpApiGetNextPendingJobTaskOptions = (options: Options<MvpApiGetNextPendingJobTaskData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetNextPendingJobTask({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetNextPendingJobTaskQueryKey(options)
    });
};

export const mvpApiListAllJobTasksQueryKey = (options?: Options<MvpApiListAllJobTasksData>) => createQueryKey('mvpApiListAllJobTasks', options);

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasksOptions = (options?: Options<MvpApiListAllJobTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListAllJobTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListAllJobTasksQueryKey(options)
    });
};

export const mvpApiListAllJobTasksInfiniteQueryKey = (options?: Options<MvpApiListAllJobTasksData>): QueryKey<Options<MvpApiListAllJobTasksData>> => createQueryKey('mvpApiListAllJobTasks', options, true);

/**
 * List All Job Tasks
 */
export const mvpApiListAllJobTasksInfiniteOptions = (options?: Options<MvpApiListAllJobTasksData>) => {
    return infiniteQueryOptions<MvpApiListAllJobTasksResponse, DefaultError, InfiniteData<MvpApiListAllJobTasksResponse>, QueryKey<Options<MvpApiListAllJobTasksData>>, number | Pick<QueryKey<Options<MvpApiListAllJobTasksData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListAllJobTasksData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListAllJobTasks({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListAllJobTasksInfiniteQueryKey(options)
    });
};

export const mvpApiTaskActivityQueryKey = (options: Options<MvpApiTaskActivityData>) => createQueryKey('mvpApiTaskActivity', options);

/**
 * Task Activity
 */
export const mvpApiTaskActivityOptions = (options: Options<MvpApiTaskActivityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiTaskActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiTaskActivityQueryKey(options)
    });
};

/**
 * Task Activity
 */
export const mvpApiTaskActivityMutation = (options?: Partial<Options<MvpApiTaskActivityData>>): UseMutationOptions<MvpApiTaskActivityResponse, DefaultError, Options<MvpApiTaskActivityData>> => {
    const mutationOptions: UseMutationOptions<MvpApiTaskActivityResponse, DefaultError, Options<MvpApiTaskActivityData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiTaskActivity({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiCreateReviewTasksQueryKey = (options: Options<MvpApiCreateReviewTasksData>) => createQueryKey('mvpApiCreateReviewTasks', options);

/**
 * Create Review Tasks
 */
export const mvpApiCreateReviewTasksOptions = (options: Options<MvpApiCreateReviewTasksData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreateReviewTasks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreateReviewTasksQueryKey(options)
    });
};

/**
 * Create Review Tasks
 */
export const mvpApiCreateReviewTasksMutation = (options?: Partial<Options<MvpApiCreateReviewTasksData>>): UseMutationOptions<MvpApiCreateReviewTasksResponse, DefaultError, Options<MvpApiCreateReviewTasksData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateReviewTasksResponse, DefaultError, Options<MvpApiCreateReviewTasksData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreateReviewTasks({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListToolWebsitesQueryKey = (options?: Options<MvpApiListToolWebsitesData>) => createQueryKey('mvpApiListToolWebsites', options);

/**
 * List Tool Websites
 */
export const mvpApiListToolWebsitesOptions = (options?: Options<MvpApiListToolWebsitesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListToolWebsites({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListToolWebsitesQueryKey(options)
    });
};

export const mvpApiShouldShowStaffToolQueryKey = (options?: Options<MvpApiShouldShowStaffToolData>) => createQueryKey('mvpApiShouldShowStaffTool', options);

/**
 * Should Show Staff Tool
 */
export const mvpApiShouldShowStaffToolOptions = (options?: Options<MvpApiShouldShowStaffToolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiShouldShowStaffTool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiShouldShowStaffToolQueryKey(options)
    });
};

export const mvpApiListOosParcelsQueryKey = (options?: Options<MvpApiListOosParcelsData>) => createQueryKey('mvpApiListOosParcels', options);

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcelsOptions = (options?: Options<MvpApiListOosParcelsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListOosParcels({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosParcelsQueryKey(options)
    });
};

export const mvpApiListOosParcelsInfiniteQueryKey = (options?: Options<MvpApiListOosParcelsData>): QueryKey<Options<MvpApiListOosParcelsData>> => createQueryKey('mvpApiListOosParcels', options, true);

/**
 * List Oos Parcels
 */
export const mvpApiListOosParcelsInfiniteOptions = (options?: Options<MvpApiListOosParcelsData>) => {
    return infiniteQueryOptions<MvpApiListOosParcelsResponse, DefaultError, InfiniteData<MvpApiListOosParcelsResponse>, QueryKey<Options<MvpApiListOosParcelsData>>, number | Pick<QueryKey<Options<MvpApiListOosParcelsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListOosParcelsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListOosParcels({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosParcelsInfiniteQueryKey(options)
    });
};

export const mvpApiGetOosParcelQueryKey = (options: Options<MvpApiGetOosParcelData>) => createQueryKey('mvpApiGetOosParcel', options);

/**
 * Get Oos Parcel
 */
export const mvpApiGetOosParcelOptions = (options: Options<MvpApiGetOosParcelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetOosParcel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetOosParcelQueryKey(options)
    });
};

export const mvpApiListOosEventBufferQueryKey = (options?: Options<MvpApiListOosEventBufferData>) => createQueryKey('mvpApiListOosEventBuffer', options);

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBufferOptions = (options?: Options<MvpApiListOosEventBufferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListOosEventBuffer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosEventBufferQueryKey(options)
    });
};

export const mvpApiListOosEventBufferInfiniteQueryKey = (options?: Options<MvpApiListOosEventBufferData>): QueryKey<Options<MvpApiListOosEventBufferData>> => createQueryKey('mvpApiListOosEventBuffer', options, true);

/**
 * List Oos Event Buffer
 */
export const mvpApiListOosEventBufferInfiniteOptions = (options?: Options<MvpApiListOosEventBufferData>) => {
    return infiniteQueryOptions<MvpApiListOosEventBufferResponse, DefaultError, InfiniteData<MvpApiListOosEventBufferResponse>, QueryKey<Options<MvpApiListOosEventBufferData>>, number | Pick<QueryKey<Options<MvpApiListOosEventBufferData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListOosEventBufferData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListOosEventBuffer({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosEventBufferInfiniteQueryKey(options)
    });
};

export const mvpApiGetOosEventFromBufferQueryKey = (options: Options<MvpApiGetOosEventFromBufferData>) => createQueryKey('mvpApiGetOosEventFromBuffer', options);

/**
 * Get Oos Event From Buffer
 */
export const mvpApiGetOosEventFromBufferOptions = (options: Options<MvpApiGetOosEventFromBufferData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetOosEventFromBuffer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetOosEventFromBufferQueryKey(options)
    });
};

export const mvpApiListOosEventBatchesQueryKey = (options?: Options<MvpApiListOosEventBatchesData>) => createQueryKey('mvpApiListOosEventBatches', options);

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatchesOptions = (options?: Options<MvpApiListOosEventBatchesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListOosEventBatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosEventBatchesQueryKey(options)
    });
};

export const mvpApiListOosEventBatchesInfiniteQueryKey = (options?: Options<MvpApiListOosEventBatchesData>): QueryKey<Options<MvpApiListOosEventBatchesData>> => createQueryKey('mvpApiListOosEventBatches', options, true);

/**
 * List Oos Event Batches
 */
export const mvpApiListOosEventBatchesInfiniteOptions = (options?: Options<MvpApiListOosEventBatchesData>) => {
    return infiniteQueryOptions<MvpApiListOosEventBatchesResponse, DefaultError, InfiniteData<MvpApiListOosEventBatchesResponse>, QueryKey<Options<MvpApiListOosEventBatchesData>>, number | Pick<QueryKey<Options<MvpApiListOosEventBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListOosEventBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListOosEventBatches({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListOosEventBatchesInfiniteQueryKey(options)
    });
};

export const mvpApiGetOosEventBatchQueryKey = (options: Options<MvpApiGetOosEventBatchData>) => createQueryKey('mvpApiGetOosEventBatch', options);

/**
 * Get Oos Event Batch
 */
export const mvpApiGetOosEventBatchOptions = (options: Options<MvpApiGetOosEventBatchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetOosEventBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetOosEventBatchQueryKey(options)
    });
};

export const mvpApiListPlanogramsQueryKey = (options?: Options<MvpApiListPlanogramsData>) => createQueryKey('mvpApiListPlanograms', options);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsOptions = (options?: Options<MvpApiListPlanogramsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListPlanograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramsQueryKey(options)
    });
};

export const mvpApiListPlanogramsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramsData>): QueryKey<Options<MvpApiListPlanogramsData>> => createQueryKey('mvpApiListPlanograms', options, true);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsInfiniteOptions = (options?: Options<MvpApiListPlanogramsData>) => {
    return infiniteQueryOptions<MvpApiListPlanogramsResponse, DefaultError, InfiniteData<MvpApiListPlanogramsResponse>, QueryKey<Options<MvpApiListPlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await mvpApiListPlanograms({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramsInfiniteQueryKey(options)
    });
};

export const mvpApiCreatePlanogramQueryKey = (options: Options<MvpApiCreatePlanogramData>) => createQueryKey('mvpApiCreatePlanogram', options);

/**
 * Create Planogram
 */
export const mvpApiCreatePlanogramOptions = (options: Options<MvpApiCreatePlanogramData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreatePlanogram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreatePlanogramQueryKey(options)
    });
};

/**
 * Create Planogram
 */
export const mvpApiCreatePlanogramMutation = (options?: Partial<Options<MvpApiCreatePlanogramData>>): UseMutationOptions<MvpApiCreatePlanogramResponse, DefaultError, Options<MvpApiCreatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreatePlanogramResponse, DefaultError, Options<MvpApiCreatePlanogramData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreatePlanogram({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramQueryKey = (options: Options<MvpApiGetPlanogramData>) => createQueryKey('mvpApiGetPlanogram', options);

/**
 * Get Planogram
 */
export const mvpApiGetPlanogramOptions = (options: Options<MvpApiGetPlanogramData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramQueryKey(options)
    });
};

export const mvpApiGetPlanogramLabelQueryKey = (options: Options<MvpApiGetPlanogramLabelData>) => createQueryKey('mvpApiGetPlanogramLabel', options);

/**
 * Get Planogram Label
 */
export const mvpApiGetPlanogramLabelOptions = (options: Options<MvpApiGetPlanogramLabelData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogramLabel({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramLabelQueryKey(options)
    });
};

/**
 * Update Planogram Label
 */
export const mvpApiUpdatePlanogramLabelMutation = (options?: Partial<Options<MvpApiUpdatePlanogramLabelData>>): UseMutationOptions<MvpApiUpdatePlanogramLabelResponse, DefaultError, Options<MvpApiUpdatePlanogramLabelData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramLabelResponse, DefaultError, Options<MvpApiUpdatePlanogramLabelData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiUpdatePlanogramLabel({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramImagesQueryKey = (options: Options<MvpApiListPlanogramImagesData>) => createQueryKey('mvpApiListPlanogramImages', options);

/**
 * List Planogram Images
 */
export const mvpApiListPlanogramImagesOptions = (options: Options<MvpApiListPlanogramImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiListPlanogramImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiListPlanogramImagesQueryKey(options)
    });
};

export const mvpApiCreatePlanogramImagesQueryKey = (options: Options<MvpApiCreatePlanogramImagesData>) => createQueryKey('mvpApiCreatePlanogramImages', options);

/**
 * Create Planogram Images
 */
export const mvpApiCreatePlanogramImagesOptions = (options: Options<MvpApiCreatePlanogramImagesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiCreatePlanogramImages({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiCreatePlanogramImagesQueryKey(options)
    });
};

/**
 * Create Planogram Images
 */
export const mvpApiCreatePlanogramImagesMutation = (options?: Partial<Options<MvpApiCreatePlanogramImagesData>>): UseMutationOptions<MvpApiCreatePlanogramImagesResponse, DefaultError, Options<MvpApiCreatePlanogramImagesData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreatePlanogramImagesResponse, DefaultError, Options<MvpApiCreatePlanogramImagesData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await mvpApiCreatePlanogramImages({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramImageQueryKey = (options: Options<MvpApiGetPlanogramImageData>) => createQueryKey('mvpApiGetPlanogramImage', options);

/**
 * Get Planogram Image
 */
export const mvpApiGetPlanogramImageOptions = (options: Options<MvpApiGetPlanogramImageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetPlanogramImage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetPlanogramImageQueryKey(options)
    });
};

export const mvpApiGetStoresInventoryQueryKey = (options?: Options<MvpApiGetStoresInventoryData>) => createQueryKey('mvpApiGetStoresInventory', options);

/**
 * Get Stores Inventory
 */
export const mvpApiGetStoresInventoryOptions = (options?: Options<MvpApiGetStoresInventoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetStoresInventory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetStoresInventoryQueryKey(options)
    });
};

export const mvpApiGetDevicesInventoryQueryKey = (options?: Options<MvpApiGetDevicesInventoryData>) => createQueryKey('mvpApiGetDevicesInventory', options);

/**
 * Get Devices Inventory
 */
export const mvpApiGetDevicesInventoryOptions = (options?: Options<MvpApiGetDevicesInventoryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await mvpApiGetDevicesInventory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: mvpApiGetDevicesInventoryQueryKey(options)
    });
};